import automation from "../assets/img/feature-icons/automation.svg";
import businessLounge from "../assets/img/feature-icons/business-lounge.svg";
import creche from "../assets/img/feature-icons/creche.svg";
import elevator from "../assets/img/feature-icons/elevator.svg";
import fourMToCeiling from "../assets/img/feature-icons/four-m-floor-to-ceiling.svg";
import glassReinforcedConcrete from "../assets/img/feature-icons/glass-reinforced-concrete.svg";
import golfGarden from "../assets/img/feature-icons/golf-garden.svg";
import greenAreas from "../assets/img/feature-icons/green-areas.svg";
import gym from "../assets/img/feature-icons/gym.svg";
import interactiveLobby from "../assets/img/feature-icons/interactive-lobby.svg";
import kohlerKitchen from "../assets/img/feature-icons/kohler-kitchen.svg";
import pentSwimmingPool from "../assets/img/feature-icons/pent-swimming-pool.svg";
import playArea from "../assets/img/feature-icons/play-area.svg";
import privateCinemas from "../assets/img/feature-icons/private-cinemas.svg";
import privateStorages from "../assets/img/feature-icons/private-storages.svg";
import tallestResiBuilding from "../assets/img/feature-icons/tallest-residential-building.svg";
import threeCarParks from "../assets/img/feature-icons/three-car-parks.svg";
import twoMaidRooms from "../assets/img/feature-icons/two-maid-rooms.svg";
import woodenEffect from "../assets/img/feature-icons/wooden-effect.svg";
import zahaHadidBathroom from "../assets/img/feature-icons/zaha-hadid-bathroom.svg";

const features = [
  {
    text: "Automation",
    icon: automation,
  },
  {
    text: "Golf Garden",
    icon: golfGarden,
  },
  {
    text: "Pent Swimming Pool",
    icon: pentSwimmingPool,
  },
  {
    text: "Tallest Resi. Building",
    icon: tallestResiBuilding,
  },
  {
    text: "Kohler Kitchen",
    icon: kohlerKitchen,
  },
  {
    text: "2 Maid Rooms",
    icon: twoMaidRooms,
  },
  {
    text: "Private Cinemas",
    icon: privateCinemas,
  },

  {
    text: "Creche",
    icon: creche,
  },
  {
    text: "Elevator",
    icon: elevator,
  },
  {
    text: "Interactive Lobby",
    icon: interactiveLobby,
  },
  {
    text: "4m Floor to Ceiling",
    icon: fourMToCeiling,
  },
  {
    text: "Play Area",
    icon: playArea,
  },
  {
    text: "Gym",
    icon: gym,
  },
  {
    text: "Zaha Hadid Bathroom",
    icon: zahaHadidBathroom,
  },
  {
    text: "3 Car Parks",
    icon: threeCarParks,
  },
  {
    text: "Green Areas",
    icon: greenAreas,
  },
  {
    text: "Private Storages",
    icon: privateStorages,
  },
  {
    text: "Business Lounge",
    icon: businessLounge,
  },
  {
    text: "Wooden Effect",
    icon: woodenEffect,
  },
  {
    text: "Glass Reinforced Concrete",
    icon: glassReinforcedConcrete,
  },
];

const apiEndpoint = "http://localhost:5001/api";
const liveApiEndpoint = "https://lobster-app-plle3.ondigitalocean.app/api";

export { features, apiEndpoint, liveApiEndpoint };
